import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';

export enum PeriodoContasPagarEnum {
    Hoje = 1,
    DaSemana = 2,
    DoMes = 3,
    Ultimos30Dias = 4,
    DoIntervalo = 5
}

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { ConfiguracaoColunasModalComponent, ColunaConfiguracao } from '../../../shared/components/configuracao-colunas-modal/configuracao-colunas-modal.component';
import { normalizarValorOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';

import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { ContasPagarRefinamentoEnum } from '../../../shared/enums/financas/contas-pagar-refinamento.enum';
import { TipoContatoEnum } from '../../../shared/enums/pessoa/tipo-contato.enum';
import { environment } from '../../../../environments/environment';

import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MaskService } from '../../../shared/services/mask.service';
import { ContasPagarService } from '../../../shared/services/apis/financas/contas-pagar.service';
import { PessoaLookupService } from '../../../shared/services/apis/pessoa/pessoa-lookup.service';

import { ContasPagarGetAllRequest } from '../../../shared/services/requests/financas/contas-pagar-get-all.request';
import { ListPessoaIdsRequest } from '../../../shared/services/requests/pessoa/list-pessoa-ids-request';
import { ContasPagarGetAllResponse } from '../../../shared/services/responses/financas/contas-pagar-get-all.response';
import { ContasPagarGridItemStruct } from '../../../shared/services/structs/financas/contas-pagar-grid-item.struct';
import { StatusContasPagarEnum } from '../../../shared/enums/financas/status-contas-pagar.enum';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { LimitDateValidator } from '../../../shared/validators/limit-date.validator';
import { ImpressaoContasPagarDialogComponent, ImpressaoContasPagarDialogData } from './dialogs/impressao-contas-pagar-dialog/impressao-contas-pagar-dialog.component';
import { ImportarContasPagarDialogComponent } from './dialogs/importar-contas-pagar-dialog/importar-contas-pagar-dialog.component';
import { EditarContasMassaDialogComponent, EditarContasMassaDialogData } from './dialogs/editar-contas-massa-dialog/editar-contas-massa-dialog.component';
import { AlterarCategoriaDialogComponent, AlterarCategoriaDialogData } from './dialogs/alterar-categoria-dialog/alterar-categoria-dialog.component';
import { AlterarTagsDialogComponent, AlterarTagsDialogData } from './dialogs/alterar-tags-dialog/alterar-tags-dialog.component';
import { PagarContasDialogComponent, PagarContasDialogData } from './dialogs/pagar-contas-dialog/pagar-contas-dialog.component';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ConfirmAcaoRecorrenteDialogComponent } from './dialogs/confirm-acao-recorrente-dialog/confirm-acao-recorrente-dialog.component';
import { AlterarFormaPagamentoDialogComponent, AlterarFormaPagamentoDialogResult } from './dialogs/alterar-forma-pagamento-dialog/alterar-forma-pagamento-dialog.component';
import { ContasPagarBulkRequest } from '../../../shared/services/requests/financas/contas-pagar-bulk.request';
import { ContasPagarBulkAlterarFormaPagamentoRequest } from '../../../shared/services/requests/financas/contas-pagar-bulk-alterar-forma-pagamento.request';
import { TipoProcessamentoRecorrenciaEnum } from '../../../shared/enums/financas/tipo-processamento-recorrencia.enum';
import { UtilService } from '../../../shared/services/util.service';

@Component({
    selector: 'app-contas-pagar-lista',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatTooltipModule,
        MatSelectModule,
        MatSortModule,
        EmptyListComponent,
        LoadingBoxDefaultListComponent,
        SelectPesquisavelComponent,
        RouterModule,
        AbntPipe,
        MatDatepickerModule,
        MatNativeDateModule,
        UiTagComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: DateAdapter, useClass: CustomDateAdapter }
    ],
    templateUrl: './contas-pagar-lista.component.html',
    styleUrls: ['./contas-pagar-lista.component.css'],
})
export class ContasPagarListaComponent implements OnInit, OnDestroy {

    // Enums
    public moduloEnum = ModuloEnum.Financas;
    public funcionalidadeEnum = FuncionalidadeEnum.Financas_Contas_Pagar;
    public _refinamentoEnum = ContasPagarRefinamentoEnum;
    public _StatusContasPagarEnum = StatusContasPagarEnum;

    // Form
    public model: FormGroup;
    public filtroRefinar: number | null = null;

    // Loading
    public _isLoading: boolean = false;

    // Dados e Paginação
    public _response: ContasPagarGetAllResponse | undefined;
    public _dataSource = new MatTableDataSource<ContasPagarGridItemStruct>();
    public _paginaAtual: number = 0;
    public _ultimaPagina: boolean = false;

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this._dataSource.sort = sort;
        this._dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'tags':
                    return normalizarValorOrdenacao(item.tags?.map(tag => tag.descricao).join(', ') ?? '');
                default:
                    return normalizarValorOrdenacao((item as any)[property] ?? '');
            }
        };
    }

    // Totais rodapé
    public _totalVencidos: number = 0;
    public _totalVencemHoje: number = 0;
    public _totalAVencer: number = 0;
    public _totalPagos: number = 0;
    public _totalPeriodo: number = 0;
    public _quantidadeLancamentos: number = 0;
    public _ocultarValores: boolean = false;

    // Mobile drawer state
    public isMobileDrawerOpen: boolean = false;

    // Seleção
    public selection = new SelectionModel<ContasPagarGridItemStruct>(true, []);

    // Colunas
    public displayedColumns: string[] = [];
    public todosCampos: ColunaConfiguracao[] = [
        { def: 'select', label: 'Seleção', visible: true, fixed: true, pinnedStart: true },
        { def: 'fornecedor', label: 'Fornecedor', visible: true, fixed: false },
        { def: 'nomeFantasia', label: 'Nome Fantasia', visible: false, fixed: false },
        { def: 'descricao', label: 'Descrição', visible: true, fixed: false },
        { def: 'numeroDocumento', label: 'Nº documento', visible: true, fixed: false },
        { def: 'categoria', label: 'Categoria', visible: false, fixed: false },
        { def: 'formaPagamento', label: 'Forma de Pagamento', visible: false, fixed: false },
        { def: 'valor', label: 'Valor', visible: true, fixed: false },
        { def: 'pago', label: 'Pago', visible: true, fixed: false },
        { def: 'aPagar', label: 'A pagar', visible: true, fixed: false },
        { def: 'vencimento', label: 'Vencimento', visible: true, fixed: false },
        { def: 'tags', label: 'Tags', visible: true, fixed: false },
        { def: 'situacao', label: 'Situação', visible: true, fixed: false },
        { def: 'actions', label: 'Ações', visible: true, fixed: true, pinnedEnd: true },
    ];

    // Listas para filtros avançados
    public listaCategoria: any[] = [];
    public listaTags: any[] = [];
    public listaStatus: any[] = [];
    public listaFormaPagamento: any[] = [];
    public listaContasFinanceiras: any[] = [];
    public listaCentrosCusto: any[] = [];
    public urlFornecedor = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Fornecedor}`;

    // Seletor de periodo
    public periodoSelecionado: PeriodoContasPagarEnum = PeriodoContasPagarEnum.DoMes;
    public PeriodoContasPagarEnum = PeriodoContasPagarEnum;
    public limiteMeses = 12;

    // Último estado de período aplicado
    private periodoSelecionadoAplicado: PeriodoContasPagarEnum = PeriodoContasPagarEnum.DoMes;
    private periodoIntervaloDeAplicado: Date | null = null;
    private periodoIntervaloAteAplicado: Date | null = null;
    private periodoMenuFoiAplicado = false;

    @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;

    constructor(
        private formBuilder: FormBuilder,
        private contasPagarService: ContasPagarService,
        private alertService: AlertService,
        private dialog: MatDialog,
        private pessoaLookupService: PessoaLookupService,
        private utilService: UtilService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.carregarLookups();
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const fimMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        this.model = this.formBuilder.group({
            pesquisa: [''],
            dataDe: [inicioMes, Validators.required],
            dataAte: [fimMes, Validators.required],
            periodoSelecionado: [PeriodoContasPagarEnum.DoMes],
            // Filtros avançados
            idStatus: [null],
            idCategoria: [null],
            idFormaPagamento: [null],
            tags: [[]],
            listaIdFornecedor: [[]],
        }, {
            validators: LimitDateValidator.rangeLimit(this.limiteMeses)
        });

        this.atualizarColunasVisiveis();
        this.loadFilters();
        this.salvarPeriodoAplicado();
        this.pesquisar();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, ['/financas/contas-pagar/cadastrar', '/financas/contas-pagar/parcela']);
    }

    private loadFilters(): void {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (filtroSalvo) {
            this.model.patchValue(filtroSalvo);
            if (filtroSalvo.periodoSelecionado != null) {
                this.periodoSelecionado = filtroSalvo.periodoSelecionado;
            }
        }
    }

    // --- Colunas configuráveis ---

    private atualizarColunasVisiveis(): void {
        this.displayedColumns = this.todosCampos
            .filter(c => c.visible)
            .map(c => c.def);
    }

    public configurarColunas(): void {
        const dialogRef = this.dialog.open(ConfiguracaoColunasModalComponent, {
            maxWidth: '700px',
            data: { colunas: this.todosCampos }
        });

        dialogRef.afterClosed().subscribe((result: ColunaConfiguracao[]) => {
            if (result) {
                this.todosCampos = result;
                this.atualizarColunasVisiveis();
            }
        });
    }

    // --- Lookups ---

    private carregarLookups(): void {
        this.contasPagarService.getLookups().subscribe({
            next: (res) => {
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                this.listaTags = res.tags;
                this.listaCategoria = res.categoriasFinanceiras;
                this.listaStatus = res.statusContasPagar;
                this.listaFormaPagamento = res.formasPagamento;
                this.listaContasFinanceiras = res.contasFinanceiras;
                this.listaCentrosCusto = res.centrosCusto;
            },
            error: (err) => {
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Pesquisa e Paginação ---

    public pesquisar(): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = this.buildRequest();

        this.contasPagarService.getAll(request, this._paginaAtual).subscribe({
            next: (response: ContasPagarGetAllResponse) => {
                if (response.isError) {
                    this._isLoading = false;
                    this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                    return;
                }

                if (!this._response) {
                    this._response = response;
                } else {
                    this._response.itens.push(...response.itens);
                }

                // Atualizar totais do rodapé (sempre vem do servidor)
                this._totalVencidos = response.totalVencidos;
                this._totalVencemHoje = response.totalVencemHoje;
                this._totalAVencer = response.totalAVencer;
                this._totalPagos = response.totalPagos;
                this._totalPeriodo = response.totalPeriodo;
                this._quantidadeLancamentos = response.quantidadeLancamentos;

                // quantidadeLancamentos já é o total do filtro (não da página) — compara com o acumulado.
                this._ultimaPagina = this._response.itens.length >= response.quantidadeLancamentos;

                this.carregarNomesFornecedores(response.itens);
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    private carregarNomesFornecedores(itensNovos: ContasPagarGridItemStruct[]): void {
        const ids = itensNovos
            .map(i => i.idFornecedor)
            .filter((id, index, self) => id != null && self.indexOf(id) === index) as number[];

        if (ids.length === 0) {
            this._isLoading = false;
            this.atualizaDataSourceNomes();
            return;
        }

        const req = new ListPessoaIdsRequest();
        req.listIdPessoa = ids;

        this.pessoaLookupService.getListPessoaIds(req).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                const dictPessoas = new Map(res.listaPessoa.map(p => [p.idPessoa, p.nome || p.nomeFantasia]));
                const dictNomeFantasia = new Map(res.listaPessoa.map(p => [p.idPessoa, p.nomeFantasia ?? null]));
                itensNovos.forEach(item => {
                    if (item.idFornecedor && dictPessoas.has(item.idFornecedor)) {
                        item.fornecedor = dictPessoas.get(item.idFornecedor)!;
                        item.nomeFantasia = dictNomeFantasia.get(item.idFornecedor) ?? null;
                    }
                });

                this.atualizaDataSourceNomes();
            },
            error: () => {
                this._isLoading = false;
                this.atualizaDataSourceNomes(); // Sempre atualiza o grid no final
            }
        });
    }

    private atualizaDataSourceNomes(): void {
        if (!this._response) return;
        this._dataSource.data = [...this._response.itens];
    }

    public clickPesquisar(): void {
        this._paginaAtual = 0;
        this._response = undefined;
        this._dataSource.data = [];
        this._ultimaPagina = false;
        this.selection.clear();
        this.pesquisar();
    }

    public aplicarFiltros(): void {
        this.clickPesquisar();
    }

    public proximaPagina(): void {
        this._paginaAtual++;
        this.pesquisar();
    }

    public limparFiltros(): void {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const fimMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        this.model.patchValue({
            pesquisa: '',
            idStatus: null,
            idCategoria: null,
            idFormaPagamento: null,
            tags: [],
            listaIdFornecedor: [],
            dataDe: inicioMes,
            dataAte: fimMes,
            periodoSelecionado: PeriodoContasPagarEnum.DoMes,
        });
        this.filtroRefinar = null;
        this.periodoSelecionado = PeriodoContasPagarEnum.DoMes;
        this.salvarPeriodoAplicado();
        this.clickPesquisar();
    }

    private buildRequest(): ContasPagarGetAllRequest {
        const request = new ContasPagarGetAllRequest();
        const formValue = this.model.getRawValue();

        request.pesquisa = formValue.pesquisa || null;
        request.refinamento = this.filtroRefinar;
        request.idStatus = formValue.idStatus || null;
        request.idCategoria = formValue.idCategoria || null;
        request.idFormaPagamento = formValue.idFormaPagamento || null;
        request.tags = formValue.tags && formValue.tags.length > 0 ? formValue.tags : null;
        request.listaIdFornecedor = formValue.listaIdFornecedor && formValue.listaIdFornecedor.length > 0 ? formValue.listaIdFornecedor : null;

        // Datas já estão no form, calculadas pelo período selecionado
        request.dataInicio = formValue.dataDe ? this.formatDate(new Date(formValue.dataDe)) : null;
        request.dataFim = formValue.dataAte ? this.formatDate(new Date(formValue.dataAte)) : null;

        return request;
    }

    // --- MÉTODOS DE PERÍODO ---

    private cloneDate(data: Date | null): Date | null {
        return data ? new Date(data) : null;
    }

    private salvarPeriodoAplicado(): void {
        this.periodoSelecionadoAplicado = this.periodoSelecionado;
        this.periodoIntervaloDeAplicado = this.cloneDate(this.model.get('dataDe')?.value);
        this.periodoIntervaloAteAplicado = this.cloneDate(this.model.get('dataAte')?.value);
        this.model.get('periodoSelecionado')?.setValue(this.periodoSelecionado, { emitEvent: false });
    }

    private restaurarPeriodoAplicado(): void {
        this.periodoSelecionado = this.periodoSelecionadoAplicado;
        this.model.patchValue({
            dataDe: this.cloneDate(this.periodoIntervaloDeAplicado),
            dataAte: this.cloneDate(this.periodoIntervaloAteAplicado),
        });
    }

    onDateInput(event: Event, controlName: 'dataDe' | 'dataAte'): void {
        MaskService.onDateInput(event, this.model.get(controlName));
    }

    prepararPeriodoIntervalo(): void {
        this.periodoMenuFoiAplicado = false;
    }

    cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
        this.restaurarPeriodoAplicado();
        this.periodoMenuFoiAplicado = true;
        const menuTrigger = trigger ?? this.periodoMenuTrigger;
        setTimeout(() => menuTrigger?.closeMenu());
    }

    onPeriodoMenuClosed(): void {
        if (!this.periodoMenuFoiAplicado) {
            this.restaurarPeriodoAplicado();
        }
    }

    get periodoLabel(): string {
        switch (this.periodoSelecionado) {
            case PeriodoContasPagarEnum.Hoje: return 'hoje';
            case PeriodoContasPagarEnum.DaSemana: return 'desta semana';
            case PeriodoContasPagarEnum.DoMes: return 'do mês';
            case PeriodoContasPagarEnum.Ultimos30Dias: return 'últimos 30 dias';
            case PeriodoContasPagarEnum.DoIntervalo: return 'do intervalo';
            default: return 'últimos 30 dias';
        }
    }

    selecionarPeriodo(periodo: PeriodoContasPagarEnum): void {
        this.periodoSelecionado = periodo;
        if (periodo !== PeriodoContasPagarEnum.DoIntervalo) {
            this.calcularDatasParaPeriodo(periodo);
        }
    }

    private calcularDatasParaPeriodo(periodo: PeriodoContasPagarEnum): void {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        let dataDe: Date;
        let dataAte: Date;

        switch (periodo) {
            case PeriodoContasPagarEnum.Hoje:
                dataDe = new Date(hoje);
                dataAte = new Date(hoje);
                break;
            case PeriodoContasPagarEnum.DaSemana: {
                dataDe = new Date(hoje);
                dataDe.setDate(hoje.getDate() - hoje.getDay());
                dataAte = new Date(dataDe);
                dataAte.setDate(dataDe.getDate() + 6);
                break;
            }
            case PeriodoContasPagarEnum.DoMes: {
                dataDe = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
                dataAte = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
                break;
            }
            case PeriodoContasPagarEnum.Ultimos30Dias:
            default: {
                dataDe = new Date(hoje);
                dataDe.setDate(hoje.getDate() - 30);
                dataAte = new Date(hoje);
                break;
            }
        }

        this.model.patchValue({ dataDe, dataAte });
    }

    aplicarPeriodo(trigger?: MatMenuTrigger): void {
        if (this.periodoSelecionado === PeriodoContasPagarEnum.DoIntervalo) {
            // Marca os campos como touched para exibir os erros do Angular
            this.model.get('dataDe')?.markAsTouched();
            this.model.get('dataAte')?.markAsTouched();

            // Checa erros específicos do LimitDateValidator ANTES do genérico,
            // pois o validator seta erros diretamente no control dataAte (tornando-o invalid)
            if (this.model.get('dataAte')?.hasError('dataInvalida')) {
                this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
                return;
            }
            if (this.model.get('dataAte')?.hasError('intervaloExcedido')) {
                this.alertService.show('Atenção', `O intervalo máximo permitido é de ${this.limiteMeses} meses.`, AlertType.warning);
                return;
            }
            // Valida required (datas vazias)
            if (this.model.get('dataDe')?.hasError('required') || this.model.get('dataAte')?.hasError('required')) {
                this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
                return;
            }
        }

        this.periodoMenuFoiAplicado = true;
        this.salvarPeriodoAplicado();
        this.clickPesquisar();
        const menuTrigger = trigger ?? this.periodoMenuTrigger;
        setTimeout(() => menuTrigger?.closeMenu());
    }

    private formatDate(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    // --- Seleção ---

    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this._dataSource.data.length;
        return numSelected === numRows;
    }

    public isAllSelectedEmAberto(): boolean {
        if (!this.selection || this.selection.selected.length === 0) return false;
        return this.selection.selected.every(item => item.idStatus === StatusContasPagarEnum.EmAberto);
    }

    public toggleAllRows(): void {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            this.selection.select(...this._dataSource.data);
        }
    }

    public checkboxLabel(row?: ContasPagarGridItemStruct): string {
        if (!row) return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.idContasPagarParcela}`;
    }

    // --- Filtros Avançados ---

    public get qtdFiltrosAvancados(): number {
        let count = 0;
        const formValue = this.model.getRawValue();

        if (formValue.idStatus) count++;
        if (formValue.idCategoria) count++;
        if (formValue.idFormaPagamento) count++;
        if (formValue.tags && formValue.tags.length > 0) count++;
        if (formValue.listaIdFornecedor && formValue.listaIdFornecedor.length > 0) count++;

        return count;
    }

    // --- Helpers de Exibição ---

    public getSituacaoClass(idStatus: number): string {
        switch (idStatus) {
            case StatusContasPagarEnum.EmAberto: return 'badge-amarelo';
            case StatusContasPagarEnum.Pago: return 'badge-verde';
            case StatusContasPagarEnum.Cancelada: return 'badge-vermelho';
            case StatusContasPagarEnum.PagoParcialmente: return 'badge-azul';
            case StatusContasPagarEnum.ConciliadoEmAberto: return 'badge-cinza';
            default: return 'badge-amarelo';
        }
    }

    public toggleOcultarValores(): void {
        this._ocultarValores = !this._ocultarValores;
    }

    public toggleGavetaMobile(): void {
        this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
        if (this.isMobileDrawerOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }
    
    public fecharGavetaMobile(): void {
        if (this.isMobileDrawerOpen) {
            this.isMobileDrawerOpen = false;
            document.body.style.overflow = '';
        }
    }

    public isAllSelectedCancelavel(): boolean {
        if (this.selection.selected.length === 0) return false;
        return this.selection.selected.every(s =>
            s.idStatus === StatusContasPagarEnum.EmAberto &&
            !s.isAgrupado &&
            s.pago === 0
        );
    }

    public isAllSelectedExcluivel(): boolean {
        if (this.selection.selected.length === 0) return false;
        return this.selection.selected.every(s =>
            (s.idStatus === StatusContasPagarEnum.EmAberto ||
                s.idStatus === StatusContasPagarEnum.Cancelada) &&
            !s.isAgrupado &&
            s.pago === 0
        );
    }

    public isAllSelectedEditavel(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.every(item => this.isEditavel(item));
    }

    public isAllSelectedPagavel(): boolean {
        return this.selection.selected.length > 0 &&
            this.selection.selected.every(item =>
                item.idStatus !== StatusContasPagarEnum.Cancelada &&
                item.idStatus !== StatusContasPagarEnum.Pago
            );
    }

    public isAllSelectedAgrupavel(): boolean {
        const itens = this.selection.selected;
        if (itens.length < 2) return false;
        const primeiroFornecedor = itens[0].idFornecedor;
        return itens.every(item =>
            item.idStatus === StatusContasPagarEnum.EmAberto &&
            !item.isAgrupado &&
            item.pago === 0 &&
            item.idFornecedor === primeiroFornecedor
        );
    }

    public isEditavel(row: ContasPagarGridItemStruct): boolean {
        return row.idStatus !== StatusContasPagarEnum.Cancelada &&
            !row.isAgrupado &&
            row.pago === 0;
    }

    public isCancelavel(row: ContasPagarGridItemStruct): boolean {
        return row.idStatus === StatusContasPagarEnum.EmAberto &&
            !row.isAgrupado &&
            row.pago === 0;
    }

    public isExcluivel(row: ContasPagarGridItemStruct): boolean {
        return (row.idStatus === StatusContasPagarEnum.EmAberto ||
            row.idStatus === StatusContasPagarEnum.Cancelada) &&
            !row.isAgrupado &&
            row.pago === 0;
    }

    public isDesagrupavel(row: ContasPagarGridItemStruct): boolean {
        return row.isAgrupado &&
            row.idStatus !== StatusContasPagarEnum.Pago &&
            row.pago === 0;
    }

    // --- Tooltips por linha ---

    public tooltipPagar(row: ContasPagarGridItemStruct): string {
        if (row.idStatus === StatusContasPagarEnum.Cancelada) return 'Conta cancelada não pode ser paga';
        if (row.idStatus === StatusContasPagarEnum.Pago) return 'Esta conta já foi totalmente paga';
        return '';
    }

    public tooltipEditar(row: ContasPagarGridItemStruct): string {
        if (row.idStatus === StatusContasPagarEnum.Cancelada) return 'Conta cancelada não pode ser editada';
        if (row.isAgrupado) return 'Conta agrupada não pode ser editada. Desfaça o agrupamento primeiro';
        if (row.pago > 0) return 'Conta com pagamento não pode ser editada. Estorne o pagamento primeiro';
        return '';
    }

    public tooltipCancelar(row: ContasPagarGridItemStruct): string {
        if (row.idStatus === StatusContasPagarEnum.Cancelada) return 'Esta conta já está cancelada';
        if (row.idStatus === StatusContasPagarEnum.Pago) return 'Conta paga não pode ser cancelada. Estorne o pagamento primeiro';
        if (row.isAgrupado) return 'Conta agrupada não pode ser cancelada. Desfaça o agrupamento primeiro';
        if (row.pago > 0) return 'Conta com pagamento parcial não pode ser cancelada. Estorne o pagamento primeiro';
        return '';
    }

    public tooltipExcluir(row: ContasPagarGridItemStruct): string {
        if (row.isAgrupado) return 'Conta agrupada não pode ser excluída. Desfaça o agrupamento primeiro';
        if (row.pago > 0) return 'Conta com pagamento não pode ser excluída. Estorne o pagamento primeiro';
        if (row.idStatus !== StatusContasPagarEnum.EmAberto && row.idStatus !== StatusContasPagarEnum.Cancelada)
            return 'Somente contas em aberto ou canceladas podem ser excluídas';
        return '';
    }

    public tooltipDesagrupar(row: ContasPagarGridItemStruct): string {
        if (row.idStatus === StatusContasPagarEnum.Pago) return 'Conta paga não pode ser desagrupada. Estorne o pagamento primeiro';
        if (row.pago > 0) return 'Conta com pagamento parcial não pode ser desagrupada. Estorne o pagamento primeiro';
        return '';
    }

    public tooltipEstorno(row: ContasPagarGridItemStruct): string {
        if (row.idStatus !== StatusContasPagarEnum.Pago
            && row.idStatus !== StatusContasPagarEnum.PagoParcialmente
            && row.pago <= 0)
            return 'Apenas contas com pagamento podem ser estornadas';
        return '';
    }

    // --- Tooltips em massa ---

    public tooltipBulkPagar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Cancelada))
            return 'Há contas canceladas na seleção';
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Pago))
            return 'Há contas já pagas na seleção';
        return '';
    }

    public tooltipBulkEditar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Cancelada))
            return 'Há contas canceladas na seleção';
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Pago || r.pago > 0))
            return 'Há contas pagas na seleção. Estorne o pagamento primeiro';
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        return '';
    }

    public tooltipBulkCancelar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Pago || r.pago > 0))
            return 'Há contas pagas na seleção. Estorne o pagamento primeiro';
        if (items.some(r => r.idStatus === StatusContasPagarEnum.Cancelada))
            return 'Há contas já canceladas na seleção';
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        return '';
    }

    public tooltipBulkAgrupar(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.length < 2) return 'Selecione ao menos 2 contas para agrupar';
        if (items.some(r => r.idStatus !== StatusContasPagarEnum.EmAberto))
            return 'Todas as contas devem estar em aberto para agrupar';
        if (items.some(r => r.isAgrupado))
            return 'Há contas já agrupadas na seleção';
        if (items.some(r => r.pago > 0))
            return 'Há contas com pagamento na seleção. Estorne primeiro';
        const fornecedorIds = new Set(items.map(r => r.idFornecedor));
        if (fornecedorIds.size > 1) return 'Todas as contas devem ser do mesmo fornecedor';
        return '';
    }

    public tooltipBulkExcluir(): string {
        if (!this.selection.hasValue()) return '';
        const items = this.selection.selected;
        if (items.some(r => r.isAgrupado))
            return 'Há contas agrupadas na seleção. Desfaça o agrupamento primeiro';
        if (items.some(r => r.pago > 0))
            return 'Há contas com pagamento na seleção. Estorne primeiro';
        if (items.some(r => r.idStatus !== StatusContasPagarEnum.EmAberto && r.idStatus !== StatusContasPagarEnum.Cancelada))
            return 'Somente contas em aberto ou canceladas podem ser excluídas';
        return '';
    }

    // --- Impressão ---

    public abrirImpressao(): void {
        const request = this.buildRequest();
        this.dialog.open(ImpressaoContasPagarDialogComponent, {
            width: '95vw',
            maxWidth: '1200px',
            height: '90vh',
            data: { filtros: request } as ImpressaoContasPagarDialogData
        });
    }

    // --- Exportação ---

    public exportarContasPagar(): void {
        const formValue = this.model.getRawValue();
        const filtrosMapeados: FiltroExtracao[] = [];

        if (formValue.pesquisa) {
            filtrosMapeados.push({ label: 'Pesquisa', formControlName: 'pesquisa', valor: formValue.pesquisa });
        }

        // Período — sempre terá datas
        const dataDe = formValue.dataDe ? new Date(formValue.dataDe) : null;
        const dataAte = formValue.dataAte ? new Date(formValue.dataAte) : null;
        const periodoLabel = this.periodoLabel;

        if (dataDe) {
            filtrosMapeados.push({
                label: 'Data Início',
                formControlName: 'dataInicio',
                valor: this.formatDate(dataDe),
                valorExibicao: dataDe.toLocaleDateString('pt-BR')
            });
        }
        if (dataAte) {
            filtrosMapeados.push({
                label: 'Data Fim',
                formControlName: 'dataFim',
                valor: this.formatDate(dataAte),
                valorExibicao: dataAte.toLocaleDateString('pt-BR')
            });
        }
        filtrosMapeados.push({
            label: 'Período',
            formControlName: 'periodoOpcao',
            valor: periodoLabel,
            valorExibicao: periodoLabel
        });

        if (formValue.idStatus) {
            const statusObj = this.listaStatus.find(s => s.idStatusContasPagar === formValue.idStatus);
            filtrosMapeados.push({ label: 'Situação', formControlName: 'idStatus', valor: formValue.idStatus, valorExibicao: statusObj ? statusObj.descricao : formValue.idStatus });
        }

        if (formValue.idCategoria) {
            const categoria = this.listaCategoria.find(c => c.idCategoriaFinanceira === formValue.idCategoria);
            filtrosMapeados.push({ label: 'Categoria', formControlName: 'idCategoria', valor: formValue.idCategoria, valorExibicao: categoria ? categoria.descricao : formValue.idCategoria });
        }

        if (formValue.idFormaPagamento) {
            const formaPagt = this.listaFormaPagamento.find(f => f.idFormaPagamento === formValue.idFormaPagamento);
            filtrosMapeados.push({ label: 'Forma de pagamento', formControlName: 'idFormaPagamento', valor: formValue.idFormaPagamento, valorExibicao: formaPagt ? formaPagt.descricao : formValue.idFormaPagamento });
        }

        if (formValue.tags && formValue.tags.length > 0) {
            const tags = formValue.tags.map((id: number) => {
                const tag = this.listaTags.find(t => t.idTagContasPagar === id);
                return tag ? tag.descricao : id;
            }).join(', ');
            filtrosMapeados.push({ label: 'Tags', formControlName: 'tags', valor: formValue.tags, valorExibicao: tags });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: 'Exportar Contas a Pagar',
            tipoExtracao: TipoExtracaoEnum.ContasPagarCSV,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.FinancasContasPagar,
            filtros: filtrosMapeados,
            possuiAutomacao: false,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            panelClass: 'extracao-dados-panel',
            disableClose: true
        });
    }

    // --- Ações (mocks) ---

    public acoesNaoImplementadas(): void {
        this.alertService.show('Info', 'Esta ação será implementada em breve.', AlertType.warning);
    }

    public abrirPagamento(contas: ContasPagarGridItemStruct[]): void {
        if (!contas || contas.length === 0) return;

        const invalidas = contas.filter(c =>
            c.idStatus !== StatusContasPagarEnum.EmAberto
            && c.idStatus !== StatusContasPagarEnum.PagoParcialmente
            && c.idStatus !== StatusContasPagarEnum.ConciliadoEmAberto);
        if (invalidas.length > 0) {
            this.alertService.show('Atenção', 'Apenas contas Em Aberto, Pagas Parcialmente ou Conciliado em Aberto podem ser pagas. Desmarque contas que já estão Canceladas ou Pagas.', AlertType.warning);
            return;
        }

        const dialogRef = this.dialog.open(PagarContasDialogComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: true,
            data: {
                parcelas: contas,
                listaCategorias: this.listaCategoria,
                listaContasFinanceiras: this.listaContasFinanceiras
            } as PagarContasDialogData
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this.clickPesquisar();
            }
        });
    }

    public abrirImportacao(): void {
        const dialogRef = this.dialog.open(ImportarContasPagarDialogComponent, {
            maxWidth: '90vw',
            maxHeight: '90vh',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.clickPesquisar();
            }
        });
    }

    // --- Deletar e Cancelar Lançamentos ---

    public excluirContas(contas: ContasPagarGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        if (itens.length === 1 && itens[0].isRecorrente) {
            const dialogRef = this.dialog.open(ConfirmAcaoRecorrenteDialogComponent, {
                width: '500px',
                data: {
                    title: 'Atenção, Conta Recorrente!',
                    description: 'Você está prestes a excluir uma conta a pagar que possui recorrência. O que deseja fazer com as contas em aberto vinculadas a essa conta?',
                    buttonConfirm: 'Excluir',
                    buttonClose: 'Cancelar',
                    confirmColor: 'warn'
                }
            });

            dialogRef.afterClosed().subscribe((res) => {
                if (res?.confirm) {
                    this.enviarExclusao(itens, res.tipoProcessamento);
                }
            });
        } else {
            const isLote = itens.length > 1;
            let msg = isLote
                ? `Você está prestes a excluir ${itens.length} contas a pagar. Tem certeza disso?`
                : `Você está prestes a excluir a conta a pagar "${itens[0].descricao}". Tem certeza disso?`;

            const qtdOriundasServicoTomado = itens.filter(i => i.isOriundaDeServicoTomado).length;
            if (qtdOriundasServicoTomado > 0) {
                msg += qtdOriundasServicoTomado === 1
                    ? ' Atenção: esta conta foi gerada por um Serviço Tomado — excluí-la aqui não exclui a nota fiscal de origem, que continuará existindo sem a conta vinculada.'
                    : ` Atenção: ${qtdOriundasServicoTomado} das contas selecionadas foram geradas por Serviços Tomados — excluí-las aqui não exclui as notas fiscais de origem, que continuarão existindo sem a conta vinculada.`;
            }

            const dialogRef = this.dialog.open(ConfirmModalComponent, {
                width: '400px',
                data: {
                    title: 'Atenção, Exclusão de Conta!',
                    description: msg,
                    buttonConfirm: 'Excluir',
                    buttonClose: 'Cancelar'
                }
            });

            dialogRef.afterClosed().subscribe((res) => {
                if (res?.confirm) {
                    this.enviarExclusao(itens, TipoProcessamentoRecorrenciaEnum.ApenasEsta);
                }
            });
        }
    }

    private enviarExclusao(itens: ContasPagarGridItemStruct[], tipoProcessamento: TipoProcessamentoRecorrenciaEnum): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = new ContasPagarBulkRequest();
        request.idsParcelas = itens.map(i => i.idContasPagarParcela);
        request.tipoProcessamentoRecorrencia = tipoProcessamento;

        this.contasPagarService.bulkDelete(request).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Contas excluídas com sucesso!", AlertType.success);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public cancelarContas(contas: ContasPagarGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        if (itens.length === 1 && itens[0].isRecorrente) {
            const dialogRef = this.dialog.open(ConfirmAcaoRecorrenteDialogComponent, {
                data: {
                    title: 'Atenção, Conta Recorrente!',
                    description: 'Você está prestes a cancelar uma conta a pagar que possui recorrência. O que deseja fazer com as contas em aberto vinculadas a essa conta?',
                    buttonConfirm: 'Confirmar cancelamento',
                    buttonClose: 'Voltar',
                }
            });

            dialogRef.afterClosed().subscribe((res) => {
                if (res?.confirm) {
                    this.enviarCancelamento(itens, res.tipoProcessamento);
                }
            });
        } else {
            const isLote = itens.length > 1;
            const msg = isLote
                ? `Você está prestes a cancelar ${itens.length} contas a pagar. Tem certeza disso?`
                : `Você está prestes a cancelar a conta a pagar "${itens[0].descricao}". Tem certeza disso?`;

            const dialogRef = this.dialog.open(ConfirmModalComponent, {
                data: {
                    title: 'Atenção, Cancelamento de Conta!',
                    description: msg,
                    buttonConfirm: 'Confirmar cancelamento',
                    buttonClose: 'Voltar'
                }
            });

            dialogRef.afterClosed().subscribe((res) => {
                if (res?.confirm) {
                    this.enviarCancelamento(itens, TipoProcessamentoRecorrenciaEnum.ApenasEsta);
                }
            });
        }
    }

    private enviarCancelamento(itens: ContasPagarGridItemStruct[], tipoProcessamento: TipoProcessamentoRecorrenciaEnum): void {
        if (this._isLoading) return;
        this._isLoading = true;

        const request = new ContasPagarBulkRequest();
        request.idsParcelas = itens.map(i => i.idContasPagarParcela);
        request.tipoProcessamentoRecorrencia = tipoProcessamento;

        this.contasPagarService.bulkCancelar(request).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Contas canceladas com sucesso!", AlertType.success);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Estorno de Pagamento ---

    public estornarPagamento(conta: ContasPagarGridItemStruct): void {
        if (!conta) return;

        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Atenção, Estorno de Pagamento!',
                description: `Você está prestes a estornar o pagamento da parcela "${conta.descricao || conta.idContasPagarParcela}". Todas as liquidações atreladas nela serão fisicamente apagadas, e o saldo das contas financeiras movimentadas será devolvido. Tem certeza disso?`,
                buttonConfirm: 'Confirmar Estorno',
                buttonClose: 'Voltar'
            }
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res?.confirm) {
                this.enviarEstorno(conta.idContasPagarParcela);
            }
        });
    }

    private enviarEstorno(idContasPagarParcela: number): void {
        if (this._isLoading) return;
        this._isLoading = true;

        this.contasPagarService.estornarPagamento(idContasPagarParcela).subscribe({
            next: (res) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', "Pagamento estornado com sucesso!", AlertType.success);
                this.clickPesquisar();
            },
            error: (err) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    // --- Alterar Tags em Massa ---

    public alterarTagsEmMassa(contas: ContasPagarGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const idsTagsAtuais = itens
            .map(i => new Set((i.tags ?? []).map(t => t.id)))
            .reduce((acc, atual) => new Set([...acc].filter(id => atual.has(id))));

        const dialogData: AlterarTagsDialogData = {
            idsContasPagarParcela: itens.map(i => i.idContasPagarParcela),
            tags: this.listaTags,
            idsTagsAtuais: Array.from(idsTagsAtuais),
        };

        const dialogRef = this.dialog.open(AlterarTagsDialogComponent, {
            width: '480px',
            maxWidth: '95vw',
            maxHeight: '95vh',
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res?.success) {
                this.clickPesquisar();
            }
        });
    }

    // --- Alterar Categoria em Massa ---

    public alterarCategoriaEmMassa(contas: ContasPagarGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const dialogData: AlterarCategoriaDialogData = {
            idsContasPagarParcela: itens.map(i => i.idContasPagarParcela),
            categoriasFinanceiras: this.listaCategoria,
        };

        const dialogRef = this.dialog.open(AlterarCategoriaDialogComponent, {
            width: '480px',
            maxWidth: '95vw',
            disableClose: true,
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((sucesso: boolean) => {
            if (sucesso) {
                this.clickPesquisar();
            }
        });
    }

    // --- Edição em Massa ---

    public editarEmMassa(): void {
        const itens = this.selection.selected;
        if (!itens || itens.length === 0) return;

        const dialogData: EditarContasMassaDialogData = {
            idsContasPagarParcela: itens.map(i => i.idContasPagarParcela),
            categoriasFinanceiras: this.listaCategoria,
            contasFinanceiras: this.listaContasFinanceiras,
            centrosCusto: this.listaCentrosCusto,
        };

        const dialogRef = this.dialog.open(EditarContasMassaDialogComponent, {
            width: '820px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: true,
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((sucesso: boolean) => {
            if (sucesso) {
                this.clickPesquisar();
            }
        });
    }

    // --- Alterar Forma de Pagamento em Massa ---

    public alterarFormaPagamento(contas: ContasPagarGridItemStruct[] | undefined = undefined): void {
        const itens = contas || this.selection.selected;
        if (!itens || itens.length === 0) return;

        const dialogRef = this.dialog.open(AlterarFormaPagamentoDialogComponent, {
            width: '500px',
            data: {
                quantidadeContas: itens.length,
                formasPagamento: this.listaFormaPagamento,
            }
        });

        dialogRef.afterClosed().subscribe((res: AlterarFormaPagamentoDialogResult) => {
            if (!res?.confirm) return;
            if (!res.idFormaPagamento) return;

            if (this._isLoading) return;
            this._isLoading = true;

            const request = new ContasPagarBulkAlterarFormaPagamentoRequest();
            request.idsParcelas = itens.map(i => i.idContasPagarParcela);
            request.idFormaPagamento = res.idFormaPagamento;

            this.contasPagarService.bulkAlterarFormaPagamento(request).subscribe({
                next: (response) => {
                    this._isLoading = false;
                    if (response.isError) {
                        this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
                        return;
                    }
                    this.alertService.show('Sucesso', 'Forma de pagamento alterada com sucesso.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err) => {
                    this._isLoading = false;
                    this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                }
            });
        });
    }

    // --- Agrupamento de Parcelas ---

    public agruparContas(): void {
        const itens = this.selection.selected;
        if (!itens || itens.length === 0) {
            this.alertService.show('Aviso', 'Selecione as parcelas que deseja agrupar.', AlertType.warning);
            return;
        }

        const idsParcelas = itens.map(i => i.idContasPagarParcela);

        this._isLoading = true;
        this.contasPagarService.validarAgrupamento({ idsParcelas }).subscribe({
            next: (res: any) => {
                this._isLoading = false;
                if (res.isError) {
                    this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
                    return;
                }

                // Navegação para a tela de cadastro com parâmetros de agrupamento
                this.router.navigate(['/financas/contas-pagar/cadastrar'], {
                    queryParams: {
                        modoAgrupamento: true,
                        idFornecedor: res.idFornecedor,
                        valorTotal: res.valorTotalAgrupamento,
                        idsParcelasOrigem: JSON.stringify(idsParcelas)
                    }
                });
            },
            error: (err: any) => {
                this._isLoading = false;
                this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
            }
        });
    }

    public desagrupar(row: ContasPagarGridItemStruct): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Desagrupar este lançamento?',
                innerHtml: 'Ao continuar, este lançamento consolidado será <b>excluído</b> e as <b>parcelas originais voltarão a ficar em aberto</b>.',
                buttonConfirm: 'Sim, desagrupar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (!result?.confirm) return;

            this._isLoading = true;
            this.contasPagarService.desagrupar(row.idContasPagar!).subscribe({
                next: (res: any) => {
                    this._isLoading = false;
                    if (res.isError) {
                        this.alertService.show('Erro', res.errorDescription || 'Erro ao desagrupar.', AlertType.error);
                        return;
                    }
                    this.alertService.show('Sucesso', 'Agrupamento desfeito com sucesso.', AlertType.success);
                    this.clickPesquisar();
                },
                error: (err: any) => {
                    this._isLoading = false;
                    this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
                }
            });
        });
    }
}
